import { render, staticRenderFns } from "./TheMessenger.vue?vue&type=template&id=1d2dd8d3&"
import script from "./TheMessenger.vue?vue&type=script&lang=js&"
export * from "./TheMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports